/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskOverviewGet } from "../funcs/riskOverviewGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskOverviewResult } from "../models/components/riskoverviewresult.js";
import {
  GetRiskOverviewRequest,
  GetRiskOverviewSecurity,
} from "../models/operations/getriskoverview.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskOverviewQueryData = RiskOverviewResult;

export function prefetchRiskOverview(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetRiskOverviewRequest | undefined,
  security?: GetRiskOverviewSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskOverviewQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskOverviewQuery(
  client$: GramCore,
  request?: GetRiskOverviewRequest | undefined,
  security?: GetRiskOverviewSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskOverviewQueryData>;
} {
  return {
    queryKey: queryKeyRiskOverview({
      from: request?.from,
      to: request?.to,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskOverviewQueryFn(
      ctx,
    ): Promise<RiskOverviewQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskOverviewGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskOverview(
  parameters: {
    from?: Date | undefined;
    to?: Date | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "overview", "get", parameters];
}
